import { faBarsFilter } from "@fortawesome/pro-solid-svg-icons/faBarsFilter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButtonProps } from "@mui/material";
import { MprcText } from "components/MprcText";
import { useMprcTheme } from "components/MprcThemeProvider";
import * as React from "react";

interface IProps {
    title?: string;
    filtered: boolean;
}

type Props = IProps & IconButtonProps;

export const MprcFilterIcon: React.FC<Props> = (props) => {
    const { theme } = useMprcTheme();
    const { filtered, title } = props;

    const lTitle = title || theme.iconButtons.IconButtonFilter.title;
    return (
        <MprcText color={filtered ? "warning" : "inherit"}>
            <FontAwesomeIcon icon={faBarsFilter} title={lTitle} />
        </MprcText>
    );
};
